export default __webpack_public_path__ + "static/media/IMG_2382_tn.0ce72b7e.jpg";